import stbAPIGateway from '../../../../services/stbAPIGateway';

export const patchClientProviderConfig = async ({ rootGetters, dispatch }, clientProvider) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.patchClientProviderConfigBySid(
    clientProvider.clientSid,
    clientProvider
  );
  if (response.status === 'success') {
    await dispatch('fetchClientProviderConfig', clientProvider.clientSid);
  }
  return response;
};
